import { useMutation } from '@tanstack/react-query';
import { getGooglePlaces } from '@/services/dashboardService';

export const useMutateLocationSuggestions = () => {
	return useMutation({
		mutationFn: getGooglePlaces
	});
};
